(function () {
  'use strict'
  var CHROME = (window.CHROME = window.CHROME || {})
  var routes = CHROME.routes || { cartAdd: '/cart/add', cartChange: '/cart/change', cart: '/cart' }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches
  var $ = function (s, r) { return (r || document).querySelector(s) }
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)) }

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = CHROME.moneyFormat || '${{amount}}'
    if (typeof cents === 'string') cents = cents.replace('.', '')
    function fmtNum(num, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision
      thousands = thousands == null ? ',' : thousands
      decimal = decimal == null ? '.' : decimal
      if (isNaN(num) || num == null) return '0'
      num = (num / 100).toFixed(precision)
      var parts = num.split('.')
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
      return dollars + (parts[1] ? decimal + parts[1] : '')
    }
    var ph = /\{\{\s*(\w+)\s*\}\}/
    var match = fmt.match(ph)
    var value
    switch (match && match[1]) {
      case 'amount_no_decimals': value = fmtNum(cents, 0); break
      case 'amount_with_comma_separator': value = fmtNum(cents, 2, '.', ','); break
      case 'amount_no_decimals_with_comma_separator': value = fmtNum(cents, 0, '.', ','); break
      case 'amount_with_space_separator': value = fmtNum(cents, 2, ' ', '.'); break
      case 'amount_no_decimals_with_space_separator': value = fmtNum(cents, 0, ' ', ''); break
      default: value = fmtNum(cents, 2)
    }
    return fmt.replace(ph, value)
  }

  /* ---------- Header transparency ---------- */
  var header = document.getElementById('SiteHeader')
  if (header && header.dataset.transparent === 'true') {
    var solid = ['bg-black/85', 'backdrop-blur-md', 'border-white/10']
    var trans = ['bg-transparent', 'border-transparent']
    var setSolid = function (on) {
      if (on) { header.classList.add.apply(header.classList, solid); header.classList.remove.apply(header.classList, trans) }
      else { header.classList.add.apply(header.classList, trans); header.classList.remove.apply(header.classList, solid) }
    }
    var onScroll = function () { setSolid(window.scrollY > 24) }
    onScroll()
    window.addEventListener('scroll', onScroll, { passive: true })
  }

  /* ---------- Mobile menu ---------- */
  var menu = $('[data-mobile-menu]')
  var menuToggle = $('[data-menu-toggle]')
  function setMenu(open) {
    if (!menu) return
    menu.classList.toggle('opacity-100', open)
    menu.classList.toggle('pointer-events-auto', open)
    menu.classList.toggle('opacity-0', !open)
    menu.classList.toggle('pointer-events-none', !open)
    if (menuToggle) menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false')
    document.body.style.overflow = open ? 'hidden' : ''
  }
  if (menuToggle) menuToggle.addEventListener('click', function () { setMenu(menu.classList.contains('opacity-0')) })

  /* ---------- Reveal on scroll ---------- */
  var reveals = $$('.reveal')
  if (reduceMotion || !('IntersectionObserver' in window)) {
    reveals.forEach(function (el) { el.classList.add('is-visible') })
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target) } })
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' })
    reveals.forEach(function (el) { io.observe(el) })
  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-cart-drawer]')
  var overlay = $('[data-cart-overlay]')
  var panel = $('[data-cart-panel]')
  var itemsEl = $('[data-cart-items]')
  var emptyEl = $('[data-cart-empty]')
  var footerEl = $('[data-cart-footer]')

  function openDrawer() {
    if (!drawer) return
    drawer.classList.add('pointer-events-auto')
    drawer.setAttribute('aria-hidden', 'false')
    if (overlay) overlay.classList.add('opacity-100')
    if (panel) panel.classList.remove('translate-x-full')
    document.body.style.overflow = 'hidden'
    refreshCart()
  }
  function closeDrawer() {
    if (!drawer) return
    drawer.classList.remove('pointer-events-auto')
    drawer.setAttribute('aria-hidden', 'true')
    if (overlay) overlay.classList.remove('opacity-100')
    if (panel) panel.classList.add('translate-x-full')
    document.body.style.overflow = ''
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = n
      if (el.closest('button')) el.classList.toggle('hidden', n === 0)
    })
  }

  function lineItemHTML(item) {
    var variant = item.variant_title && item.variant_title.indexOf('Default') === -1
      ? '<p class="mt-0.5 text-xs text-white/35">' + item.variant_title + '</p>' : ''
    var img = item.image ? '<img src="' + item.image + '" alt="" class="h-full w-full object-contain p-1.5">' : ''
    return (
      '<li class="flex gap-4" data-line="' + item.key + '">' +
        '<div class="relative h-20 w-20 shrink-0 overflow-hidden border border-white/10 bg-black">' + img + '</div>' +
        '<div class="flex flex-1 flex-col">' +
          '<div class="flex justify-between gap-3">' +
            '<p class="font-display text-sm font-semibold leading-snug text-white">' + item.product_title + '</p>' +
            '<p class="font-display text-sm text-white/80">' + formatMoney(item.final_line_price) + '</p>' +
          '</div>' + variant +
          '<div class="mt-auto flex items-center justify-between pt-3">' +
            '<div class="flex items-center border border-white/15">' +
              '<button type="button" data-qty-down class="flex h-8 w-8 items-center justify-center text-white/70 hover:text-white" aria-label="Decrease">&minus;</button>' +
              '<span class="w-9 text-center font-display text-sm text-white">' + item.quantity + '</span>' +
              '<button type="button" data-qty-up class="flex h-8 w-8 items-center justify-center text-white/70 hover:text-white" aria-label="Increase">&#43;</button>' +
            '</div>' +
            '<button type="button" data-remove class="text-xs uppercase tracking-[0.12em] text-white/35 hover:text-white">Remove</button>' +
          '</div>' +
        '</div>' +
      '</li>'
    )
  }

  function renderCart(cart) {
    setCount(cart.item_count)
    var hasItems = cart.item_count > 0
    if (emptyEl) emptyEl.classList.toggle('hidden', hasItems)
    if (itemsEl) itemsEl.classList.toggle('hidden', !hasItems)
    if (footerEl) footerEl.classList.toggle('hidden', !hasItems)
    if (itemsEl && hasItems) itemsEl.innerHTML = '<ul class="space-y-6">' + cart.items.map(lineItemHTML).join('') + '</ul>'
    var sub = $('[data-cart-subtotal]')
    if (sub) sub.textContent = formatMoney(cart.total_price)
  }

  function refreshCart() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json() }).then(renderCart).catch(function () {})
  }

  function changeLine(key, qty) {
    return fetch(routes.cartChange + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty }),
    }).then(function (r) { return r.json() }).then(renderCart)
  }

  if (itemsEl) {
    itemsEl.addEventListener('click', function (e) {
      var li = e.target.closest('[data-line]')
      if (!li) return
      var key = li.getAttribute('data-line')
      var qtyEl = li.querySelector('span')
      var qty = parseInt(qtyEl ? qtyEl.textContent : '1', 10)
      if (e.target.closest('[data-qty-up]')) changeLine(key, qty + 1)
      else if (e.target.closest('[data-qty-down]')) changeLine(key, Math.max(0, qty - 1))
      else if (e.target.closest('[data-remove]')) changeLine(key, 0)
    })
  }

  $$('[data-cart-toggle]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); setMenu(false); openDrawer() }) })
  $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', closeDrawer) })
  if (overlay) overlay.addEventListener('click', closeDrawer)
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeDrawer(); setMenu(false) } })

  /* ---------- Add to cart (AJAX) ---------- */
  document.addEventListener('submit', function (e) {
    var form = e.target
    if (!(form instanceof HTMLFormElement)) return
    var submitter = e.submitter
    if (!submitter || !submitter.hasAttribute('data-add-to-cart')) return
    e.preventDefault()
    submitter.disabled = true
    var prev = submitter.textContent
    submitter.textContent = 'Adding…'
    fetch(routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json() })
      .then(function () { return refreshCart() })
      .then(function () { openDrawer() })
      .catch(function () {})
      .then(function () { submitter.disabled = false; submitter.textContent = prev })
  })

  /* ---------- Variant selection ---------- */
  $$('[data-product-variants]').forEach(function (node) {
    var form = node.closest('form')
    if (!form) return
    var variants
    try { variants = JSON.parse(node.textContent || '[]') } catch (err) { return }
    var selects = $$('[data-variant-option]', form)
    var idInput = $('[data-variant-id]', form)
    var priceEl = $('[data-price]')
    var addBtn = $('[data-add-to-cart]', form)
    var addLabel = addBtn ? addBtn.textContent.trim() : 'Add to Cart'
    function update() {
      var chosen = selects.map(function (s) { return s.value })
      var match = null
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i]
        if (v.options.length === chosen.length && v.options.every(function (o, idx) { return o === chosen[idx] })) { match = v; break }
      }
      if (!match) return
      if (idInput) idInput.value = match.id
      if (priceEl) priceEl.textContent = formatMoney(match.price)
      if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? addLabel : 'Sold out' }
    }
    selects.forEach(function (s) { s.addEventListener('change', update) })
  })

  /* ---------- Product gallery (carousel) ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var track = $('[data-gallery-track]', g)
    if (!track) return
    var slides = $$('[data-gallery-slide]', g)
    var thumbs = $$('[data-gallery-thumb]', g)
    if (slides.length < 2) return
    var current = 0
    function setActive(i) {
      current = Math.max(0, Math.min(slides.length - 1, i))
      thumbs.forEach(function (t, idx) {
        var on = idx === current
        t.classList.toggle('border-white/70', on)
        t.classList.toggle('border-white/15', !on)
      })
    }
    function goTo(i) {
      var ni = Math.max(0, Math.min(slides.length - 1, i))
      track.scrollTo({ left: ni * track.clientWidth, behavior: 'smooth' })
      setActive(ni)
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { goTo(i) }) })
    var prev = $('[data-gallery-prev]', g)
    var next = $('[data-gallery-next]', g)
    if (prev) prev.addEventListener('click', function () { goTo(current - 1) })
    if (next) next.addEventListener('click', function () { goTo(current + 1) })
    var st
    track.addEventListener('scroll', function () {
      clearTimeout(st)
      st = setTimeout(function () { setActive(Math.round(track.scrollLeft / track.clientWidth)) }, 90)
    }, { passive: true })
    setActive(0)
  })

  /* ---------- Consent banner ---------- */
  var KEY = 'chromeplus.consent'
  var consent = $('[data-consent]')
  if (consent) {
    try { if (!localStorage.getItem(KEY)) consent.classList.remove('hidden') } catch (err) {}
    var save = function (analytics) {
      try { localStorage.setItem(KEY, JSON.stringify({ essential: true, analytics: analytics, ts: Date.now() })) } catch (err) {}
      consent.classList.add('hidden')
    }
    var a = $('[data-consent-accept]'); var es = $('[data-consent-essential]')
    if (a) a.addEventListener('click', function () { save(true) })
    if (es) es.addEventListener('click', function () { save(false) })
  }

  /* ---------- Order tracking ---------- */
  var trackGo = $('[data-track-go]')
  if (trackGo) {
    var run = function () {
      var input = $('[data-track-input]')
      var err = $('[data-track-error]')
      var val = (input && input.value || '').trim()
      if (!val) { if (err) { err.textContent = 'Enter the tracking number from your shipping email.'; err.classList.remove('hidden') } return }
      window.open('https://t.17track.net/en#nums=' + encodeURIComponent(val), '_blank', 'noopener')
    }
    trackGo.addEventListener('click', run)
    var ti = $('[data-track-input]')
    if (ti) ti.addEventListener('keydown', function (e) { if (e.key === 'Enter') run() })
  }
})()
